import BrandApprovedCheckbox from './BrandApprovedCheckbox';

export default BrandApprovedCheckbox;
